
import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = 'h-10 md:h-12 w-auto max-w-[220px] md:max-w-[260px]' }) => {
  return (
    <img
      src="/dist/blueterra_logo.png"
      alt="BLUETERRA"
      className={`object-contain object-left ${className}`}
    />
  );
};

export default Logo;
